import { swiperDefaults } from '../globals.js'

import Swiper from 'swiper'
import { A11y, Navigation } from 'swiper/modules';
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

/**
 * Best Use Mobile Slider
 */
const mediaQuery = window.matchMedia('(max-width:64em)')
let swiperInstance = false

function handleResizeChange (e) {
    // Check if the media query is true
    if (e.matches) {
        if (document.querySelector('[data-filters-slider]')) {
            swiperInstance = new Swiper('[data-filters-slider]', {
                pagination: {
                    el: '[data-filters-slider] .slider-pagination',
                    type: 'bullets',
                    bulletClass: 'slider-pagination__item',
                    bulletActiveClass: 'slider-pagination__item--active',
                    clickable: true
                },
                navigation: {
                    nextEl: '[data-filters-slider] .slider-navigation__next',
                    prevEl: '[data-filters-slider] .slider-navigation__prev',
                    hiddenClass: 'slider-navigation--hidden',
                    disabledClass: 'slider-navigation--disabled'
                },
                slidesPerView: 'auto',
                spaceBetween: 15,
                slidesPerGroup: 2,
                modules: [Navigation, A11y]
            })
            return
        }
    }

    if (swiperInstance) swiperInstance.destroy(true, true)

    // Removing within the slider init function does not work, we need to set a timeout to remove unnecessary aria attrs
    setTimeout(() => {
        const ariaLiveEls = document.querySelectorAll('.swiper [aria-live]')
        removeAriaAttr(ariaLiveEls, 'aria-live')
    }, 500)
}

// Remove unnecessary aria attributes
function removeAriaAttr (els, attr) {
    els.forEach(el => {
        el.removeAttribute(attr)
        el.setAttribute('aria-hidden', 'false')
    })
}

// Register event listener
mediaQuery.addListener(handleResizeChange)

// Initial check
handleResizeChange(mediaQuery)

/**
 * Sticky Sidebar
 */
const sidebar = document.querySelector('[data-sticky-sidebar]')

const sidebarWillFit = () => {
    return window.innerHeight >= (sidebar.getBoundingClientRect().height + 120)
}

if (sidebar && sidebarWillFit()) {
    sidebar.classList.add('isSticky')
}
